import { ref } from 'vue'
import { defineStore } from 'pinia'
import { api } from '@/request'
import Cookies from 'js-cookie'

export const useUserStore = defineStore('user', () => {
  const userInfo = ref(null);
  const isAuth = ref<boolean>(false);
  const userProfile = ref(null);

  const getUserData = async () => {
    if((!localStorage.getItem('token') || !Cookies.get('GATEWAY')) && !Cookies.get('HASH_SESSION')) {
      return
    }
    userProfile.value = (await api.get(`/proxy/profile-api.bpmn/api/v1/profile/user`)).data
    isAuth.value = true;
    userInfo.value = {
      email: userProfile.value.email,
      phone: userProfile.value.phone?.trim(),
      lastName: userProfile.value.lastname?.trim(),
      firstName: userProfile.value.firstname?.trim(),
      lang: userProfile.value.lang,
      avatar: '/img/default-avatar.svg'
    }

    try {
      const avatar = (await api.get(`/proxy/profile-api.bpmn/api/v1/profile/avatar`, {
        responseType: 'blob' as 'json',
      })).data
      userInfo.value.avatar = avatar.size ? URL.createObjectURL(avatar) : '/img/default-avatar.svg'
    } catch {}
    updateNameFields()
  }

  const updateNameFields = () => {
    if(userInfo.value) {
      userInfo.value.formatPhone = formatPhoneNumber(userInfo.value.phone?.trim());
      userInfo.value.fullName = (userInfo.value.firstName + ' ' + userInfo.value.lastName).trim();
    }
  };

  const logout = () => {
    localStorage.clear()
    sessionStorage.clear();
    isAuth.value = false;
    userInfo.value = null;
    api.get(`/proxy/account-recovery-api.bpmn/auth/logout`)
  }

  const formatPhoneNumber = (phone) => {
    if(!phone) {
      return ''
    }
    const match = phone.match(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/);
    return match ? `+${match[1]} ${match[2]} ${match[3]} ${match[4]} ${match[5]}` : phone;
  }

  const updateToken = async (token, refresh) => {
    if(import.meta.env.DEV) {
      localStorage.setItem('token', token)
      localStorage.setItem('refresh_token', refresh)
    }
    await getUserData()
  }

  return {
    userInfo,
    isAuth,
    getUserData,
    logout,
    updateToken,
    userProfile
  }
})
